module.exports = __webpack_public_path__ + "static/media/logo.ca1a7586.png";